// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 453 ? "eef9e134" : chunkId) + "." + {"143":"b34734b517c00b45","231":"65581a1007cbf45c","407":"f1a44ed2adfcfec9","453":"cfc8a89debae3465","609":"cb8dba965500a230","686":"5fd61ee027f0974e","852":"7cbc26af23d4998d"}[chunkId] + ".js";
};